import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBars,
  faTimes,
  faGraduationCap,
  faTrophy,
  faMapLocationDot,
  faSackDollar,
  faChartLine,
  faHandshake,
  faCalculator,
  faArrowsRotate,
  faLaptop,
  faHouseChimney,
  faHouseUser,
  faBaby,
  faHardHat,
  faCircleInfo,
  faFileLines,
  faShieldHalved,
  faPiggyBank,
  faHeartPulse,
} from "@fortawesome/free-solid-svg-icons";
import { useEffect, useState } from "react";
import { Navbar, Nav, Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import "../styles/navbar.css";
import Image from "react-bootstrap/Image";
import corporateLogo from "../assets/corporate_logo.png";
import retailLogo from "../assets/retail_logo.png";
import {
  CORPORATE_HOME,
  RETAIL_HOME,
  RETAIL_ROUTES,
  MODE_RETAIL,
} from "../lib/siteMode";
import { useSiteMode } from "./SiteModeProvider";
import MegaDropdown from "./MegaDropdown";

const ABOUT_MENU = [
  {
    to: "/impresszum",
    icon: faFileLines,
    title: "Impresszum",
    description: "Cégadatok és jogi információk.",
  },
  {
    to: "/adatkezelesi-tajekoztato",
    icon: faShieldHalved,
    title: "Adatkezelési tájékoztató",
    description: "Hogyan kezeljük és védjük a személyes adataidat.",
  },
];

const SUPPORT_MENU = [
  {
    to: "/dualis-kepzes",
    icon: faGraduationCap,
    title: "Duális képzés",
    description:
      "Állami támogatással segítünk a duális képzési programok elindításában.",
  },
];

const LOANS_MENU = [
  {
    to: "/vallalati-hitel",
    icon: faSackDollar,
    title: "Vállalati hitel",
    description: "Bankfüggetlen hiteltanácsadás és ajánlatkérés cégeknek.",
  },
  {
    to: "/szamlaoptimalizalas",
    icon: faChartLine,
    title: "Számlaoptimalizálás",
    description: "Vállalati bankszámla és díjstruktúra optimalizálása.",
  },
];

const GRANTS_MENU = [
  {
    to: "/nemzeti-bajnokok",
    icon: faTrophy,
    title: "Nemzeti Bajnokok",
    description: "Pályázati támogatás nemzeti bajnok minősítésű vállalatoknak.",
  },
  {
    to: "/elmaradott-tersegek-tamogatasa",
    icon: faMapLocationDot,
    title: "Hátrányos helyzetű régiók",
    description: "Beruházási támogatás hátrányos helyzetű térségekben.",
  },
  {
    to: "/penzugyi-orangyal",
    icon: faHandshake,
    title: "Partnerség",
    description: "Csatlakozz partnerprogramunkhoz és ajánlj ügyfeleket.",
  },
];

const PERSONAL_LOAN_MENU = [
  {
    to: `${RETAIL_ROUTES.szemelyiKolcson}#faq`,
    icon: faArrowsRotate,
    title: "Hitelkiváltás",
    description:
      "Válts kedvezőbb THM-ű személyi kölcsönre, és válts ki meglévő hiteleid.",
  },
  {
    to: RETAIL_ROUTES.szemelyiKolcson,
    icon: faLaptop,
    title: "Online személyi kölcsön",
    description:
      "Igényeld teljesen online, személyes bankfióki ügyintézés nélkül.",
  },
  {
    to: `${RETAIL_ROUTES.szemelyiKolcson}#calculation`,
    icon: faCalculator,
    title: "Személyi kölcsön kalkulátor",
    description: "Számold ki az illusztratív havi törlesztőrészletet.",
  },
];

const MORTGAGE_MENU = [
  {
    to: `${RETAIL_ROUTES.jelzaloghitel}#jogosultsag`,
    icon: faHouseChimney,
    title: "Otthon Start hitel",
    description:
      "Kedvezményes kamatozású állami hitelprogram első lakásvásárláshoz.",
  },
  {
    to: RETAIL_ROUTES.jelzaloghitel,
    icon: faHouseUser,
    title: "CSOK Plusz",
    description:
      "Gyermekes családok lakáscélú állami támogatása kedvezményes hitellel.",
  },
  {
    to: `${RETAIL_ROUTES.jelzaloghitel}#calculation`,
    icon: faCalculator,
    title: "Lakáshitel kalkulátor",
    description:
      "Számold ki az illusztratív törlesztőt, és nézd meg az LTV-jogosultságod.",
  },
];

const BANK_ACCOUNT_MENU = [
  {
    to: `${RETAIL_ROUTES.bankszamla}#compare`,
    icon: faCalculator,
    title: "Bankszámla kalkulátor",
    description:
      "Hasonlítsd össze a bankok díjait, és becsüld meg éves költséged.",
  },
];

const INSURANCE_MENU = [
  {
    to: RETAIL_ROUTES.nyugdijmegtakaritas,
    icon: faPiggyBank,
    title: "Nyugdíjmegtakarítás",
    description: "Önkéntes nyugdíjpénztár vagy NYESZ, állami adójóváírással.",
  },
  {
    to: RETAIL_ROUTES.eletbiztositas,
    icon: faHeartPulse,
    title: "Életbiztosítás",
    description:
      "Kockázati vagy megtakarítási életbiztosítás a családod védelmére.",
  },
];

const SUBSIDIZED_PRODUCTS_MENU = [
  {
    to: RETAIL_ROUTES.szemelyiKolcson,
    icon: faBaby,
    title: "Babaváró hitel",
    description:
      "Állami támogatású, gyermekvállaláshoz kötött kedvezményes személyi kölcsön.",
  },
  {
    to: RETAIL_ROUTES.szemelyiKolcson,
    icon: faHardHat,
    title: "Munkáshitel",
    description:
      "Fiatal munkavállalóknak szóló, állami kamattámogatású személyi kölcsön.",
  },
  {
    to: RETAIL_ROUTES.jelzaloghitel,
    icon: faHouseUser,
    title: "CSOK Plusz",
    description:
      "Gyermekes családok lakáscélú állami támogatása kedvezményes hitellel.",
  },
];

export default function MainNavbar() {
  const isRetail = useSiteMode() === MODE_RETAIL;
  const logo = isRetail ? retailLogo : corporateLogo;

  const [scrolled, setScrolled] = useState(false);
  const [expanded, setExpanded] = useState(false);
  const [openMenuCount, setOpenMenuCount] = useState(0);

  useEffect(() => {
    function onScroll() {
      if (window.scrollY > 30) setScrolled(true);
      else setScrolled(false);
    }

    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const closeMobileMenu = () => setExpanded(false);
  const handleMenuOpenChange = (isOpen) =>
    setOpenMenuCount((count) => Math.max(0, count + (isOpen ? 1 : -1)));

  const modeSwitcher = (
    <div
      className="site-mode-switch"
      role="tablist"
      aria-label="Vállalati vagy lakossági oldal"
    >
      <Link
        to={CORPORATE_HOME}
        role="tab"
        aria-selected={!isRetail}
        className={`site-mode-pill ${!isRetail ? "active" : ""}`}
        onClick={closeMobileMenu}
      >
        Vállalati
      </Link>
      <Link
        to={RETAIL_HOME}
        role="tab"
        aria-selected={isRetail}
        className={`site-mode-pill ${isRetail ? "active" : ""}`}
        onClick={closeMobileMenu}
      >
        Lakossági
      </Link>
    </div>
  );

  return (
    <Container
      className={`custom-navbar p-0 ${scrolled ? "navbar-scrolled" : ""} ${
        expanded || openMenuCount > 0 ? "navbar-expanded" : ""
      }`}
    >
      <Navbar
        expand="md"
        className="py-1 nav-links mx-2"
        expanded={expanded}
        onToggle={() => setExpanded(!expanded)}
      >
        <Navbar.Brand
          as={Link}
          to={isRetail ? RETAIL_HOME : CORPORATE_HOME}
          className="navbar-brand-custom p-0"
        >
          <Image
            src={logo}
            alt="Financials.hu"
            height="50"
            width="50"
            className="logo-hover-bg"
          />
        </Navbar.Brand>

        <Navbar.Collapse id="main-navbar">
          <div className="d-md-none mobile-menu-switcher">{modeSwitcher}</div>
          {isRetail ? (
            <Nav className="ms-auto py-3 py-md-0">
              <MegaDropdown
                label="Személyi kölcsön"
                to={RETAIL_ROUTES.szemelyiKolcson}
                items={PERSONAL_LOAN_MENU}
                onNavigate={closeMobileMenu}
                onOpenChange={handleMenuOpenChange}
              />
              <MegaDropdown
                label="Lakáshitel"
                to={RETAIL_ROUTES.jelzaloghitel}
                items={MORTGAGE_MENU}
                onNavigate={closeMobileMenu}
                onOpenChange={handleMenuOpenChange}
              />
              <MegaDropdown
                label="Bankszámla"
                to={RETAIL_ROUTES.bankszamla}
                items={BANK_ACCOUNT_MENU}
                onNavigate={closeMobileMenu}
                onOpenChange={handleMenuOpenChange}
              />
              <MegaDropdown
                label="Biztosítás"
                items={INSURANCE_MENU}
                onNavigate={closeMobileMenu}
                onOpenChange={handleMenuOpenChange}
              />
              <MegaDropdown
                label="Támogatások"
                items={SUBSIDIZED_PRODUCTS_MENU}
                onNavigate={closeMobileMenu}
                onOpenChange={handleMenuOpenChange}
              />
              <MegaDropdown
                label="Rólunk"
                to="/rolunk"
                items={ABOUT_MENU}
                onNavigate={closeMobileMenu}
                onOpenChange={handleMenuOpenChange}
              />
            </Nav>
          ) : (
            <Nav className="ms-auto py-3 py-md-0">
              <MegaDropdown
                label="Támogatások"
                to="/dualis-kepzes"
                items={SUPPORT_MENU}
                onNavigate={closeMobileMenu}
                onOpenChange={handleMenuOpenChange}
              />
              <MegaDropdown
                label="Hitelek"
                items={LOANS_MENU}
                onNavigate={closeMobileMenu}
                onOpenChange={handleMenuOpenChange}
              />
              <MegaDropdown
                label="Pályázatok"
                items={GRANTS_MENU}
                onNavigate={closeMobileMenu}
                onOpenChange={handleMenuOpenChange}
              />
              <MegaDropdown
                label="Rólunk"
                to="/rolunk"
                items={ABOUT_MENU}
                onNavigate={closeMobileMenu}
                onOpenChange={handleMenuOpenChange}
              />
            </Nav>
          )}
        </Navbar.Collapse>

        <div className="navbar-end-group">
          <div className="d-none d-md-flex">{modeSwitcher}</div>

          <Navbar.Toggle
            aria-controls="main-navbar"
            className="custom-toggler border-0 shadow-none"
          >
            <FontAwesomeIcon
              icon={expanded ? faTimes : faBars}
              className="toggler-icon"
            />
            <span className="toggler-label">Menü</span>
          </Navbar.Toggle>
        </div>
      </Navbar>
    </Container>
  );
}
